export enum OrgPlanningGuidelineConstraint {
  MinSpanOfControl = 'MinSpanOfControl',
  MaxSpanOfControl = 'MaxSpanOfControl',
  EmptyHeadPosition = 'EmptyHeadPosition',
  MultipleHeadPositions = 'MultipleHeadPositions',
  NoHeadPosition = 'NoHeadPosition',
  EmptyOrganisation = 'EmptyOrganisation',
  MaxOrgLevel = 'MaxOrgLevel'
}
